import api from '../../utils/api'

import { useState } from 'react'



/* Hooks */
import useFlashMessage from '../../hooks/useFlashMessage'

/* form */
import FormAviamento from './form/FormAviamento'

function NewAviamento({ btCancelAction, handleOnSuccess }) {
    const [token] = useState(localStorage.getItem('token') || '')
    const { setFlashMessage } = useFlashMessage()



    async function registerAviamento(aviamento) {
        let msgType = 'success'

        const data = await api.post('/aviamento/new', aviamento, {
            headers: {
                Authorization: `Bearer ${JSON.parse(token)}`,
            },

        }).then((response) => {
            return response.data
        })
            .catch((err) => {
                msgType = 'error'
                return err.response.data
            })

        setFlashMessage(data.message, msgType)

        if (msgType !== 'error') {

            handleOnSuccess()
        }
    }

    return (
        <FormAviamento title="Cadastrar Aviamento" handleSubmit={registerAviamento} btCancelAction={btCancelAction} btnText="Cadastrar" />
    )
}

export default NewAviamento
